import { render, staticRenderFns } from "./OrderCostsGraph.vue?vue&type=template&id=2cb4d210&scoped=true&"
import script from "./OrderCostsGraph.vue?vue&type=script&lang=js&"
export * from "./OrderCostsGraph.vue?vue&type=script&lang=js&"
import style0 from "./OrderCostsGraph.vue?vue&type=style&index=0&id=2cb4d210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4d210",
  null
  
)

export default component.exports